export const isLastElement = <T>(arr: T[], index: number): boolean => index === arr.length - 1
